import React, { forwardRef } from 'react';

const Container = forwardRef((props, ref) => {
  return (
    <section ref={ref} className={`w-full ${props._parentClass}`} data-aos-offset="500"
    data-aos-duration="500"
    data-aos-once="true"
    data-aos-easing="ease-in-sine">  
      <div className={`container`}>
      <div className="flex flex-wrap">
      {props.children}
        </div>
      </div>
    </section>
  );
});

export default Container;
